import { FunctionComponent } from "react";
import TopNav from "../../components/navigation/TopNav";
import MobileNav from "../../components/navigation/MobileNav";
import Contact from "../../components/website/Contact";
import Footer from "../../components/website/Footer";
import AboutContent from "../../components/website/about/AboutContent";


const About: FunctionComponent = () => (
    <div className="max-w-[1440px] mx-auto w-full">
        <TopNav />
        <MobileNav />
        <AboutContent />
        <Contact />
        <Footer />
    </div>  
);


export default About;


